import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Article, Payment, PaymentMethod, PaymentUpdate, Student} from "../../models/eventRequest";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {PaymentService} from "../../_services/payment.service";
import * as moment from "moment";

declare let $ : any;

@Component({
  selector: 'app-payment-update-form',
  templateUrl: './payment-update-form.component.html',
  styleUrls: ['./payment-update-form.component.css']
})
export class PaymentUpdateFormComponent implements OnInit {
  paymentForm = this.initForm();

  @Input()
  iNavMobile: boolean = false;

  @Input()
  iStudent?: Student;

  @Input()
  iPayment?: PaymentUpdate;

  @Input()
  iPaymentMethods: PaymentMethod[] = [];

  @Output()
  oPaymentUpdated: EventEmitter<Payment> = new EventEmitter();

  @Output()
  oRefundRequested: EventEmitter<PaymentUpdate> = new EventEmitter();

  paymentSubmited = false;
  popupError = '';
  updateInvoice = true;

  isRefund = false;

  constructor(private fb:UntypedFormBuilder, private paymentService: PaymentService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.paymentForm = this.resetForm();
    this.isRefund = false;
  }

  private resetForm() : UntypedFormGroup {
    return  this.fb.group({
      paymentId: [this.iPayment?.paymentId, Validators.required],
      invoiceNumber: [this.iPayment?.invoiceNumber],
      date: [moment.utc(this.iPayment?.date).format('YYYY-MM-DD'), Validators.required],
      amount: [this.iPayment?.amount, Validators.required],
      paymentMethod: [this.iPayment?.paymentMethod, Validators.required],
      description: [this.iPayment?.description]
    });
  }

  onUpdatePayment() {
    let payment = this.paymentForm?.value;
    // Si remboursement, on peut ajouter une logique spécifique ici si besoin
    this.paymentService.updatePayment(payment).subscribe(
      updatedPayment => {
        this.oPaymentUpdated.emit(updatedPayment);
        this.paymentForm = this.resetForm();
        this.paymentSubmited = false;
        $("#updatePaymentModal").modal("hide");
        this.isRefund = false;
      },
      err => {
        this.popupError = err.error.message;
      }
    );
  }

  isPaymentSubmited(form: UntypedFormGroup) {
    this.paymentSubmited = true;
  }

  onRefund() {
    this.isRefund = true;
    // Optionnel : on peut pré-remplir certains champs ou vider le montant
    this.paymentForm.patchValue({
      amount: '',
      description: '',
    });
  }

  openRefundPopup(payment: PaymentUpdate) {
    this.iPayment = payment;
    this.isRefund = true;
    this.paymentForm = this.resetForm();
    // On vide le montant et la description pour le remboursement
    this.paymentForm.patchValue({
      amount: '',
      description: '',
    });
    // Ouvre le modal
    $("#updatePaymentModal").modal("show");
  }

  private initForm() {
    return  this.fb.group({
      paymentId: this.iPayment?.paymentId,
      invoiceNumber: this.iPayment?.invoiceNumber,
      date: this.iPayment?.date,
      amount: this.iPayment?.amount,
      paymentMethod: this.iPayment?.paymentMethod,
      description: this.iPayment?.description
    });
  }
}
